import React from "react";
import { Typography, makeStyles, Box } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 500
  },
  alertBlock: {
    width: "100%",
    marginTop: theme.spacing(4),
    boxSizing: "border-box",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2, 3),
    "& .MuiTypography-root": {
      fontSize: "0.75rem",
      lineHeight: "0.875rem"
    }
  },
  success: {
    background: "rgba(7, 163, 90, 0.08)",
    "& .MuiTypography-root": { color: "#07A35A" }
  },
  warning: {
    padding: theme.spacing(3),
    background: "#FAE6E3",
    "& .MuiTypography-root": { color: "#D93024" }
  }
}));

export default function MessageBox({ variant = "success", title, subtitle }) {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.alertBlock, classes[variant])}>
      {title && <Typography className={classes.title}>{title}</Typography>}
      {subtitle && (
        <Typography className={classes.subtitle}>{subtitle}</Typography>
      )}
    </Box>
  );
}
